import { render, staticRenderFns } from "./document-details-history.vue?vue&type=template&id=404e03ea&scoped=true&"
import script from "./document-details-history.vue?vue&type=script&lang=js&"
export * from "./document-details-history.vue?vue&type=script&lang=js&"
import style0 from "./document-details-history.vue?vue&type=style&index=0&id=404e03ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404e03ea",
  null
  
)

component.options.__file = "document-details-history.vue"
export default component.exports